import React from 'react'
import { Link } from 'react-router'
import formatDate from 'dateformat'

import classNames from './AlbumInfo.css'
import GroupedKeywords from '../GroupedKeywords'

export default function AlbumInfo (props) {
  const { params, album, owner, lists, resolvedKeywords } = props
  const inLists = lists ? getLists(album, lists) : []
  const getKeywordName = id => props.keywordMap[id].name
  return (
    <div className={classNames.page}>
      <ul className={classNames.info}>
        <li><b>Created by</b> {owner && owner.name}</li>
        <li><b>Created</b> {getDate(album.created_at)}</li>
        {album.updated_at &&
          <li><b>Last updated</b> {getDate(album.updated_at)}</li>
        }
        {inLists.length !== 0 &&
          <li><b>Lists</b> {inLists}</li>
        }
        {props.hasDynamicLink && props.keywordMap && resolvedKeywords && resolvedKeywords.length !== 0 &&
          <li><b>Resolved keywords</b> {resolvedKeywords.map(getKeywordName).join(', ')}</li>
        }
      </ul>
      <GroupedKeywords albumID={params.id} />
    </div>
  )
}

function getDate (string) {
  if (!string) return string
  return formatDate(new Date(string), 'HH:MM, d mmmm yyyy')
}

function getLists (album, lists) {
  return lists.filter(list => {
    return list.albums.findIndex(a => a.id === album.id) !== -1
  }).map((list, index, array) => {
    const comma = index === array.length - 1 ? null : ', '
    return [
      <Link key='link' to={`/group/${list.id}`}>
        {list.name}
      </Link>, comma
    ]
  })
}



// WEBPACK FOOTER //
// ./src/components/album/AlbumInfo.js